import React, {Fragment, useState} from "react";
import ProtectedContent from "../../components/ProtectedContent";
import SafeView from "../../components/safeView/SafeView";
import InventoryReportsHeader from "./InventoryReportsHeader";
import InventoryReportsTable from "./inventoryReportsTable";

const InventoryReports = () => {
  const [activeFilters, setActiveFilters] = useState([]);

  return (
    <SafeView>
      <ProtectedContent perms={[]} showFallback>
        <Fragment>
          <InventoryReportsHeader activeFilters={activeFilters} />
          <div className="table-container">
            <InventoryReportsTable onFiltersChange={setActiveFilters} />
          </div>
        </Fragment>
      </ProtectedContent>
    </SafeView>
  );
};

export default InventoryReports;
